module.exports = __webpack_public_path__ + "img/home_btn_play.afc2a505.svg";